import { gql } from 'apollo-angular';

export const CALCULATE_REFUELED_TOTAL_SUM_QUERY = gql`
query CalculateRefueledTotalSum($orderId: UUID!) {
  calculateRefueledTotalSum(orderId: $orderId)
}
`;

export interface CalculateRefueledTotalSumQueryResponse {
  calculateRefueledTotalSum: number | null;
  loading: boolean;
}
